import React from "react";
import { Star } from "lucide-react";

const reviews = [
  {
    name: "Sarah H.",
    location: "Cardiff Bay",
    text: "Absolutely brilliant from quote to unload. The team packed our fragile items beautifully and made a stressful day feel easy. Highly recommend BoxB!",
  },
  {
    name: "James R.",
    location: "Penarth",
    text: "Booked a same-day office relocation and BoxB delivered. Careful, professional and much more affordable than the big-name firms.",
  },
  {
    name: "Priya M.",
    location: "Newport",
    text: "Used BoxB for our house move and end of tenancy clean. Got our full deposit back and the movers were so friendly. 5 stars from us.",
  },
  {
    name: "Owen T.",
    location: "Barry",
    text: "Man and van service was spot on — quick response on WhatsApp, honest pricing, no surprises. Will use them again.",
  },
];

export const Reviews = () => (
  <section id="reviews" data-testid="reviews-section" className="py-20 md:py-32 bg-[#F8FAFC]">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="max-w-2xl">
        <span className="text-xs tracking-[0.22em] uppercase font-bold text-[#2563EB]">Reviews</span>
        <h2 className="mt-4 font-display font-semibold text-[#0A192F] text-4xl sm:text-5xl tracking-tight">
          Real moves. Real reviews.
        </h2>
        <p className="mt-4 text-lg text-slate-600">
          Trusted by families, students and businesses across South Wales.
        </p>
      </div>

      <div className="mt-14 grid md:grid-cols-2 gap-6">
        {reviews.map((r, i) => (
          <figure key={r.name} data-testid={`review-card-${i}`}
                  className="hover-lift rounded-3xl bg-white border border-slate-200 p-8">
            <div className="flex items-center gap-1 text-[#0A192F]">
              {["s1","s2","s3","s4","s5"].map((k) => (<Star key={`${r.name}-${k}`} className="h-4 w-4 fill-current" />))}
            </div>
            <blockquote className="mt-5 text-lg leading-relaxed text-slate-700">
              &ldquo;{r.text}&rdquo;
            </blockquote>
            <figcaption className="mt-6 flex items-center gap-3">
              <span className="inline-flex h-10 w-10 rounded-full bg-gradient-to-br from-[#0A192F] to-[#2563EB] items-center justify-center font-display font-bold text-white">
                {r.name[0]}
              </span>
              <div>
                <div className="font-semibold text-[#0A192F]">{r.name}</div>
                <div className="text-sm text-slate-500">{r.location}</div>
              </div>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);
